import api from './api';

export interface User {
  id: number;
  username: string;
  email: string;
  profile_picture?: string | null;
  full_name: string;
  designation?: string | null;
  pr_report_frequency?: 'daily' | 'weekly' | 'none';
  stock_report_frequency?: 'daily' | 'weekly' | 'none';
  dye_stock_email_enabled?: number | boolean;
  role: 'admin' | 'manager' | 'technician' | 'viewer' | 'machine';
  assigned_machine?: string;
  is_active: number;
  allowed_systems?: string[];
  created_at: string;
  updated_at: string;
}

export interface CreateUserData {
  username: string;
  email: string;
  password: string;
  full_name: string;
  designation?: string;
  pr_report_frequency?: 'daily' | 'weekly' | 'none';
  stock_report_frequency?: 'daily' | 'weekly' | 'none';
  dye_stock_email_enabled?: boolean;
  role: 'admin' | 'manager' | 'technician' | 'viewer' | 'machine';
  assigned_machine?: string;
  allowed_systems?: string[];
}

export interface UpdateUserData {
  username?: string;
  email?: string;
  password?: string;
  full_name?: string;
  designation?: string;
  pr_report_frequency?: 'daily' | 'weekly' | 'none';
  stock_report_frequency?: 'daily' | 'weekly' | 'none';
  dye_stock_email_enabled?: boolean;
  role?: 'admin' | 'manager' | 'technician' | 'viewer' | 'machine';
  assigned_machine?: string;
  is_active?: number;
  allowed_systems?: string[];
}

export const userService = {
  getAll: async () => {
    const response = await api.get('/users');
    return response.data;
  },

  getById: async (id: number) => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  create: async (data: CreateUserData) => {
    const response = await api.post('/users', data);
    return response.data;
  },

  update: async (id: number, data: UpdateUserData) => {
    const response = await api.put(`/users/${id}`, data);
    return response.data;
  },

  delete: async (id: number) => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },
};
